// Keep in sync with apps/portal-be/src/main/java/com/crespect/portal/biz/company/type/DateFormat.java.
export type DateOrder = 'YMD' | 'DMY' | 'MDY';
export type DateSeparator = '-' | '/' | '.';

const ORDER_PARTS: Record<DateOrder, [string, string, string]> = {
    YMD: ['yyyy', 'MM', 'dd'],
    DMY: ['dd', 'MM', 'yyyy'],
    MDY: ['MM', 'dd', 'yyyy'],
};

export const DATE_ORDERS: DateOrder[] = ['YMD', 'DMY', 'MDY'];
export const DATE_SEPARATORS: DateSeparator[] = ['-', '/', '.'];

export const DEFAULT_DATE_FORMAT_PATTERN = 'yyyy-MM-dd';

export const composeDateFormat = (order: DateOrder, separator: DateSeparator): string =>
    ORDER_PARTS[order].join(separator);

export const decomposeDateFormat = (
    pattern: string | null | undefined
): { order: DateOrder; separator: DateSeparator } | null => {
    if (!pattern) return null;
    for (const order of DATE_ORDERS) {
        for (const separator of DATE_SEPARATORS) {
            if (composeDateFormat(order, separator) === pattern) {
                return { order, separator };
            }
        }
    }
    return null;
};

/** The pattern without its year, for a date whose year goes without saying: 'dd.MM.yyyy' gives 'dd.MM'. */
export const withoutYear = (pattern: string): string => {
    const parts = decomposeDateFormat(pattern);
    return parts ? ORDER_PARTS[parts.order].filter((part) => part !== 'yyyy').join(parts.separator) : pattern;
};
